import {
  ProductCalculation,
  UnderlyingDataType,
} from 'src/apis/capacity-management/types';
import * as pp from 'src/utils/page-params';

type Options = {
  calculation?: ProductCalculation;
};

export function usePageParams({ calculation }: Options) {
  const underlyingDataParam =
    calculation?.type === 'FIRM_DAY' || calculation?.type === 'FIRM_WITHINDAY'
      ? 'FDAUIOLI_CAPACITY'
      : 'TECHNICAL_CAPACITY';

  return pp.usePageParams(
    pp
      .configure()
      .add(pp.start('start'))
      .add(pp.number('pageSize').default(5))
      .add(
        pp
          .param('underlyingData')
          .default<UnderlyingDataType>(underlyingDataParam)
          .filter({ label: 'Underlying Data' })
      )
  );
}

export type PageParams = ReturnType<typeof usePageParams>;
